<script>
import bem from '@/utils/bem';
import ModalWrapper from '@/components/modals/Modal-wrapper.vue';

const b = bem('custom-footer-editor');

export default {
  components: {
    ModalWrapper,
  },
  data() {
    return {
      visible: true,
      // Top block settings
      showTopBlock: this.content.showTopBlock !== undefined
        ? this.content.showTopBlock : true,
      topBlockText: this.content.topBlockText
        || 'Explore Exciting Content From Our Team.',
      showBlogButton: this.content.showBlogButton !== undefined
        ? this.content.showBlogButton : true,
      blogButtonText: this.content.blogButtonText || 'VINTAGE UNIVERSITY BLOG',
      blogButtonUrl: this.content.blogButtonUrl || 'https://foreverstudios.com/blog/',

      // Social links
      showSocialLinks: this.content.showSocialLinks !== undefined
        ? this.content.showSocialLinks : true,
      showFacebook: this.content.showFacebook !== undefined
        ? this.content.showFacebook : true,
      facebookUrl: this.content.facebookUrl || 'https://www.facebook.com/ForeverStudiosFL',
      showTwitter: this.content.showTwitter !== undefined ? this.content.showTwitter : true,
      twitterUrl: this.content.twitterUrl || 'https://twitter.com/Forever_studios',
      showInstagram: this.content.showInstagram !== undefined ? this.content.showInstagram : true,
      instagramUrl: this.content.instagramUrl || 'https://www.instagram.com/forever_studios/',
      showYoutube: this.content.showYoutube !== undefined ? this.content.showYoutube : true,
      youtubeUrl: this.content.youtubeUrl || 'https://www.youtube.com/channel/UCgyUMV4HWMx-XasFPTc7cyQ',

      // Bottom navigation links
      showBottomLinks: this.content.showBottomLinks !== undefined
        ? this.content.showBottomLinks : true,
      showDigitizeLink: this.content.showDigitizeLink !== undefined
        ? this.content.showDigitizeLink : true,
      digitizeLinkText: this.content.digitizeLinkText || 'DIGITIZE',
      digitizeLinkUrl: this.content.digitizeLinkUrl
        || 'https://foreverstudios.com/media-digitizing-service/',
      showEnhanceLink: this.content.showEnhanceLink !== undefined
        ? this.content.showEnhanceLink : true,
      enhanceLinkText: this.content.enhanceLinkText || 'ENHANCE',
      enhanceLinkUrl: this.content.enhanceLinkUrl || 'https://foreverstudios.com/old-photo-restoration/',
      showPrintLink: this.content.showPrintLink !== undefined ? this.content.showPrintLink : true,
      printLinkText: this.content.printLinkText || 'PRINT',
      printLinkUrl: this.content.printLinkUrl || 'https://foreverstudios.com/create-photo-art/',

      // Copyright and contact
      copyrightText: this.content.copyrightText || '© 2025 Legacy Media Group, LLC',
      showPhone: this.content.showPhone !== undefined ? this.content.showPhone : true,
      phoneNumber: this.content.phoneNumber || '800-916-6076',
      phoneUrl: this.content.phoneUrl || 'tel:800-916-6076',
      showAddress: this.content.showAddress !== undefined ? this.content.showAddress : true,
      addressText: this.content.addressText || '1000 Clint Moore Road, Suite 208, Boca Raton, FL 33487, United States',
      addressUrl: this.content.addressUrl || 'https://www.google.com/maps/place/1000+Clint+Moore+Rd+%23+208,+Boca+Raton,+FL+33487',
    };
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: false,
      default: () => {},
    },
    save: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    handleSave() {
      this.save({
        // Top block
        showTopBlock: this.showTopBlock,
        topBlockText: this.topBlockText,
        showBlogButton: this.showBlogButton,
        blogButtonText: this.blogButtonText,
        blogButtonUrl: this.blogButtonUrl,

        // Social links
        showSocialLinks: this.showSocialLinks,
        showFacebook: this.showFacebook,
        facebookUrl: this.facebookUrl,
        showTwitter: this.showTwitter,
        twitterUrl: this.twitterUrl,
        showInstagram: this.showInstagram,
        instagramUrl: this.instagramUrl,
        showYoutube: this.showYoutube,
        youtubeUrl: this.youtubeUrl,

        // Bottom links
        showBottomLinks: this.showBottomLinks,
        showDigitizeLink: this.showDigitizeLink,
        digitizeLinkText: this.digitizeLinkText,
        digitizeLinkUrl: this.digitizeLinkUrl,
        showEnhanceLink: this.showEnhanceLink,
        enhanceLinkText: this.enhanceLinkText,
        enhanceLinkUrl: this.enhanceLinkUrl,
        showPrintLink: this.showPrintLink,
        printLinkText: this.printLinkText,
        printLinkUrl: this.printLinkUrl,

        // Copyright and contact
        copyrightText: this.copyrightText,
        showPhone: this.showPhone,
        phoneNumber: this.phoneNumber,
        phoneUrl: this.phoneUrl,
        showAddress: this.showAddress,
        addressText: this.addressText,
        addressUrl: this.addressUrl,
      });
    },
  },
  watch: {
    visible(newValue) {
      if (!newValue) {
        this.close();
      }
    },
  },
};
</script>

<template>
  <modal-wrapper v-model:show="visible" width="700px">
    <div :class="b()">
      <div :class="b('title')">Custom Footer Settings</div>

      <!-- Top Block Section -->
      <div :class="b('section')">
        <div :class="b('section-header')">
          <div :class="b('section-title')">Top Block</div>
          <a-switch
            v-model:checked="showTopBlock"
            checked-children="Show"
            un-checked-children="Hide"
          />
        </div>

        <template v-if="showTopBlock">
          <div :class="b('field')">
            <div :class="b('field-label')">Top Block Text</div>
            <a-input
              v-model:value="topBlockText"
              placeholder="Explore Exciting Content From Our Team."
            />
          </div>

          <div :class="b('field')">
            <div :class="b('field-toggle')">
              <span :class="b('field-label')">Show Blog Button</span>
              <a-switch
                v-model:checked="showBlogButton"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
          </div>

          <template v-if="showBlogButton">
            <div :class="b('field')">
              <div :class="b('field-label')">Blog Button Text</div>
              <a-input
                v-model:value="blogButtonText"
                placeholder="VINTAGE UNIVERSITY BLOG"
              />
            </div>

            <div :class="b('field')">
              <div :class="b('field-label')">Blog Button URL</div>
              <a-input
                v-model:value="blogButtonUrl"
                placeholder="https://foreverstudios.com/blog/"
              />
            </div>
          </template>
        </template>
      </div>

      <!-- Social Links Section -->
      <div :class="b('section')">
        <div :class="b('section-header')">
          <div :class="b('section-title')">Social Links</div>
          <a-switch
            v-model:checked="showSocialLinks"
            checked-children="Show"
            un-checked-children="Hide"
          />
        </div>

        <template v-if="showSocialLinks">
          <div :class="b('social-grid')">
            <!-- Facebook -->
            <div :class="b('social-item')">
              <div :class="b('field-toggle')">
                <span :class="b('field-label')">Facebook</span>
                <a-switch
                  v-model:checked="showFacebook"
                  checked-children="Yes"
                  un-checked-children="No"
                />
              </div>
              <a-input
                v-if="showFacebook"
                v-model:value="facebookUrl"
                placeholder="https://www.facebook.com/..."
                size="small"
              />
            </div>

            <!-- Twitter -->
            <div :class="b('social-item')">
              <div :class="b('field-toggle')">
                <span :class="b('field-label')">Twitter</span>
                <a-switch
                  v-model:checked="showTwitter"
                  checked-children="Yes"
                  un-checked-children="No"
                />
              </div>
              <a-input
                v-if="showTwitter"
                v-model:value="twitterUrl"
                placeholder="https://twitter.com/..."
                size="small"
              />
            </div>

            <!-- Instagram -->
            <div :class="b('social-item')">
              <div :class="b('field-toggle')">
                <span :class="b('field-label')">Instagram</span>
                <a-switch
                  v-model:checked="showInstagram"
                  checked-children="Yes"
                  un-checked-children="No"
                />
              </div>
              <a-input
                v-if="showInstagram"
                v-model:value="instagramUrl"
                placeholder="https://www.instagram.com/..."
                size="small"
              />
            </div>

            <!-- YouTube -->
            <div :class="b('social-item')">
              <div :class="b('field-toggle')">
                <span :class="b('field-label')">YouTube</span>
                <a-switch
                  v-model:checked="showYoutube"
                  checked-children="Yes"
                  un-checked-children="No"
                />
              </div>
              <a-input
                v-if="showYoutube"
                v-model:value="youtubeUrl"
                placeholder="https://www.youtube.com/..."
                size="small"
              />
            </div>
          </div>
        </template>
      </div>

      <!-- Bottom Navigation Links -->
      <div :class="b('section')">
        <div :class="b('section-header')">
          <div :class="b('section-title')">Bottom Navigation Links</div>
          <a-switch
            v-model:checked="showBottomLinks"
            checked-children="Show"
            un-checked-children="Hide"
          />
        </div>

        <template v-if="showBottomLinks">
          <!-- Digitize Link -->
          <div :class="b('field')">
            <div :class="b('field-toggle')">
              <span :class="b('field-label')">Digitize Link</span>
              <a-switch
                v-model:checked="showDigitizeLink"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
          </div>
          <template v-if="showDigitizeLink">
            <div :class="b('field-row')">
              <a-input
                v-model:value="digitizeLinkText"
                placeholder="DIGITIZE"
                style="width: 150px;"
              />
              <a-input
                v-model:value="digitizeLinkUrl"
                placeholder="URL"
                style="flex: 1;"
              />
            </div>
          </template>

          <!-- Enhance Link -->
          <div :class="b('field')">
            <div :class="b('field-toggle')">
              <span :class="b('field-label')">Enhance Link</span>
              <a-switch
                v-model:checked="showEnhanceLink"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
          </div>
          <template v-if="showEnhanceLink">
            <div :class="b('field-row')">
              <a-input
                v-model:value="enhanceLinkText"
                placeholder="ENHANCE"
                style="width: 150px;"
              />
              <a-input
                v-model:value="enhanceLinkUrl"
                placeholder="URL"
                style="flex: 1;"
              />
            </div>
          </template>

          <!-- Print Link -->
          <div :class="b('field')">
            <div :class="b('field-toggle')">
              <span :class="b('field-label')">Print Link</span>
              <a-switch
                v-model:checked="showPrintLink"
                checked-children="Yes"
                un-checked-children="No"
              />
            </div>
          </div>
          <template v-if="showPrintLink">
            <div :class="b('field-row')">
              <a-input
                v-model:value="printLinkText"
                placeholder="PRINT"
                style="width: 150px;"
              />
              <a-input
                v-model:value="printLinkUrl"
                placeholder="URL"
                style="flex: 1;"
              />
            </div>
          </template>
        </template>
      </div>

      <!-- Copyright and Contact Section -->
      <div :class="b('section')">
        <div :class="b('section-title')">Copyright & Contact</div>

        <div :class="b('field')">
          <div :class="b('field-label')">Copyright Text</div>
          <a-input
            v-model:value="copyrightText"
            placeholder="© 2025 Legacy Media Group, LLC"
          />
        </div>

        <div :class="b('field')">
          <div :class="b('field-toggle')">
            <span :class="b('field-label')">Show Phone</span>
            <a-switch
              v-model:checked="showPhone"
              checked-children="Yes"
              un-checked-children="No"
            />
          </div>
        </div>
        <template v-if="showPhone">
          <div :class="b('field-row')">
            <a-input
              v-model:value="phoneNumber"
              placeholder="800-916-6076"
              style="width: 200px;"
            />
            <a-input
              v-model:value="phoneUrl"
              placeholder="tel:800-916-6076"
              style="flex: 1;"
            />
          </div>
        </template>

        <div :class="b('field')">
          <div :class="b('field-toggle')">
            <span :class="b('field-label')">Show Address</span>
            <a-switch
              v-model:checked="showAddress"
              checked-children="Yes"
              un-checked-children="No"
            />
          </div>
        </div>
        <template v-if="showAddress">
          <div :class="b('field')">
            <a-textarea
              v-model:value="addressText"
              placeholder="1000 Clint Moore Road, Suite 208..."
              :rows="2"
            />
          </div>
          <div :class="b('field')">
            <a-input
              v-model:value="addressUrl"
              placeholder="https://www.google.com/maps/..."
            />
          </div>
        </template>
      </div>

      <div :class="b('buttons')">
        <a-button
          type="primary"
          html-type="button"
          @click="handleSave"
        >
          Save
        </a-button>
        <a-button
          html-type="button"
          @click="close"
        >
          Cancel
        </a-button>
      </div>
    </div>
  </modal-wrapper>
</template>

<style scoped lang="scss">
.custom-footer-editor {
  padding: 20px;
  max-height: 80vh;
  overflow-y: auto;

  &__title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #293241;
  }

  &__section {
    margin-bottom: 24px;
    padding: 16px;
    background-color: #f5f5f5;
    border-radius: 8px;
  }

  &__section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__section-title {
    font-size: 16px;
    font-weight: 600;
    color: #5f8aa4;
  }

  &__field {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__field-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #293241;
  }

  &__field-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__field-row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
  }

  &__social-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  &__social-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__buttons {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
  }
}
</style>
